<div class="content-wrapper-inner relative">
    <div *ngIf="loading" class="spinner">
        <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <app-users-form (onAfterSave)="afterSave($event)"></app-users-form>
</div>
